/**
 * Hero Video
 */

export default function HWY_HeroVideo() {
  this.init = () => {
    if (
      jQuery(".secondary-block-right .lead-image").length > 1 &&
      jQuery(".secondary-block-right").length > 0
    ) {
      jQuery(".secondary-block-right").addClass("owl-carousel owl-theme");
      jQuery(".secondary-block-right .lead-image").each(function () {
        jQuery(this).addClass("item");
      });
      jQuery(document).ready(function ($) {
        $(".secondary-block-right").owlCarousel({
          items: 1,
          loop: true,
        });
      });
    }
    turnLight();
  };
  const turnLight = () => {
    setTimeout(function () {
      var imageUrl = jQuery(".hero-background-image").data("image");
      jQuery(".hero-background-image").css(
        "background-image",
        "url(" + imageUrl + ")"
      );
    }, 3000);
  };
}
